var s1 = "/static/c29f23261a13fd14.png";

export { s1 as default };
//# sourceMappingURL=s_1.png.js.map
